<template>
  <div>
    <div class="center-middle min-vh-100" v-if="announcement === null">
      <loading-state :size="50" />
    </div>
    <div v-else>
      <PageTitle :title="announcement.title" />
      <div class="row">
        <div class="col-md-12">
          <Card
            :title="`${dateFormat(announcement.post_date)} - ${dateFormat(
              announcement.post_date,
              'h:mm a'
            )}`"
            class="white-space-content"
          >
            {{ announcement.body }}
          </Card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "@vue/composition-api";
import Card from "@/components/display/Card";
import { dateFormat } from "leatherman-js/utils/formatters/time";
import LoadingState from "@/components/display/LoadingState";
import PageTitle from "@/components/display/PageTitle";
import store from "@/store";

export default {
  name: "AnnouncementDetailPage",
  components: {
    Card,
    LoadingState,
    PageTitle,
  },
  props: {
    announcementId: [String, Number],
  },
  setup(props) {
    const loading = ref(true);
    const announcement = ref(null);

    onMounted(() => {
      store.dispatch("announcements/get", props.announcementId).then((data) => {
        announcement.value = data;
        loading.value = false;
      });
    });

    return {
      loading,
      announcement,
      dateFormat,
    };
  },
};
</script>
